import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppButton.css"; // 👈 import your custom styles

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/+4915155629922?text=Hallo%20Herr%20Gjocaj,%20ich%20hätte%20eine%20Projektanfrage%20für%20Sie." // replace number
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-btn" // 👈 your own class
    >
      <FaWhatsapp size={32} color="white" />
    </a>
  );
}
